module.exports = __webpack_public_path__ + "img/z4.7e590f0f.png";